jQuery(function ($) {
  window.dataLayer = window.dataLayer || []
  window._mtm = window._mtm || []

  $(document).on('nfFormSubmitResponse', function (event, response, id) {
    if (response.response.errors.length) return;
    const formSubmissionData = {
      'event': 'form-submission',
      'form': {
        'id': response.id,
        'values': response.response.data.fields_by_key,
      },
    };
    window.dataLayer.push(formSubmissionData);
    window._mtm.push(formSubmissionData);
  })
})

jQuery(document).ready(function($) {
  var $cookieLink = $('.inpFooter__menus--menu a[href="#cookies"]');

  if ($cookieLink.length) {
    $cookieLink.on('click', function(e) {
      e.preventDefault();

      if (window.axeptioSDK) {
        axeptioSDK.openCookies();
      } else if (typeof openAxeptioCookies === 'function') {
        openAxeptioCookies();
      }
    });
  }
});
